import React from 'react';
import { HERO_IMAGE, HERO_IMAGE_ALT } from '../data/product';
import { VolumeCover } from './VolumeCover';

/** Title lines and event-group colour as they print on each cover. */
const COVERS: {
  number: number;
  lines: string[];
  color: string;
  sessions: number;
}[] = [{
  number: 1,
  lines: ['Day One', 'Ready'],
  color: 'team',
  sessions: 21
}, {
  number: 2,
  lines: ['Speed', 'Ready'],
  color: '#C8452B',
  sessions: 22
}, {
  number: 3,
  lines: ['Jumps', 'Ready'],
  color: '#E89B0C',
  sessions: 20
}, {
  number: 4,
  lines: ['Throws', 'Ready'],
  color: '#2E7D4F',
  sessions: 21
}, {
  number: 5,
  lines: ['Distance', 'Ready'],
  color: '#2563A8',
  sessions: 21
}, {
  number: 6,
  lines: ['Meet Season', 'Ready'],
  color: 'team',
  sessions: 16
}];

/**
 * Stack order, back to front: each volume sits a step up and to the right of
 * the one in front, so its band and name show like a tab. Volume 1 in front.
 */
const STACK = [6, 5, 4, 3, 2, 1];
const STEP_X = 2.6;
const STEP_Y = 7.2;
type ProductVisualProps = {
  className?: string;
  /** Show the highlighter "121 sessions" seal. */
  seal?: boolean;
  lazy?: boolean;
};

/**
 * The pack. Shows the uploaded mockup when HERO_IMAGE is set; otherwise draws
 * the six landscape volumes in code, stacked like cards on a clipboard.
 */
export function ProductVisual({
  className = '',
  seal = true,
  lazy = false
}: ProductVisualProps) {
  if (HERO_IMAGE) {
    return <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} width={2048} height={1360} loading={lazy ? 'lazy' : undefined} className={`block h-auto w-full rounded-2xl border border-white/10 shadow-book sm:rounded-3xl ${className}`} data-id="element-344" data-mp="2n2aygbjk4p7p" />;
  }
  return <div className={`relative mx-auto aspect-[4/3] w-full ${className}`} role="img" aria-label={HERO_IMAGE_ALT} data-id="element-345" data-mp="2s1fbxedil93u">
      {/* soft pool of stadium light under the pack */}
      <span className="absolute inset-x-[10%] bottom-[6%] h-[20%] rounded-[50%] bg-black/45 blur-2xl" aria-hidden="true" data-id="element-346" data-mp="12otvsewo6giz" />
      <div aria-hidden="true" className="absolute inset-0 -rotate-3" data-id="element-347" data-mp="2xr74wc67f7ql">
        {STACK.map(vol => {
        const cover = COVERS[vol - 1];
        const k = vol - 1;
        return <VolumeCover key={vol} number={cover.number} lines={cover.lines} color={cover.color} sessions={cover.sessions} peek={vol !== 1} className="!absolute w-[70%]" style={{
          left: `${9 + k * STEP_X}%`,
          bottom: `${9 + k * STEP_Y}%`,
          zIndex: 10 - k,
          filter: vol === 1 ? undefined : `brightness(${1 - k * 0.07})`
        }} data-id="element-348" data-mp="36qkct0eojo97" />;
      })}
      </div>

      {seal && <div className="absolute right-[1%] top-[2%] z-10 flex h-[22%] w-auto aspect-square rotate-[8deg] flex-col items-center justify-center rounded-full bg-hl text-center text-hl-ink shadow-lift ring-4 ring-hl/30" aria-hidden="true" data-id="element-349" data-mp="3adb2zfts132">
          <span className="font-display text-[clamp(18px,4.2vw,34px)] font-bold leading-none" data-id="element-350" data-mp="ieg0ns9xcgax">121</span>
          <span className="mt-0.5 max-w-[80%] text-[clamp(7px,1.2vw,10px)] font-bold uppercase leading-tight tracking-wide" data-id="element-351" data-mp="dg4v3tqnwryi">
            ready-to-run practices
          </span>
        </div>}
    </div>;
}